(function ($) {

	'use strict';

	/**
	 * initializes the counter containers
	 * @returns {undefined}
	 */
	$.initCounterContainers = function () {

		let $counters = $('.purecounter');

		if ($counters.length > 0) {
			let fetchCounters = [];
			$counters.each(function () {
				let $counterContainer = $(this);
				// url example:  /api/v1/counter/KZKATID/col/A => { status: true, code: 200, value: <number>}
				let url = `/api/v1/counter/${$counterContainer.attr('data-id')}/col/${$counterContainer.attr('data-col')}`;

				let belno = $(this).attr('data-belno');


				if (typeof belno !== typeof undefined && belno !== false) {
					url += `/belno/${belno}`;
				}

				fetchCounters.push(fetch(url)
					.then(response => response.json())
					.catch(error => {
						return {status: true, code: 200, value: 0};
					})
					.then(result => {
						if (!result.status) {
							result.value = 0;
						}
						$counterContainer.attr('data-purecounter-end', result.value);
					})
				);
			});

			Promise.all(fetchCounters)
				.then(() => $('body').append($('<script src="/js/purecounter/purecounter_vanilla.js"></script>')));

		}

	};	// $.initCounterContainers

}(jQuery));

